export default __webpack_public_path__ + "9a75949b7b657b98a929cf8fe10d01d4.svg";